<ng-container>
  <div class="banner" role="banner"></div>
</ng-container>

<div class="container">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
